const roles = {
  moduleTitle: "الصلاحيات",
  actions: {
    create: "إنشاء دور",
    view: "عرض",
    edit: "تعديل",
    save: "حفظ",
    cancel: "إلغاء",
    delete: "حذف",
  },
  permissions: {
    core: "النواة",
    permissionManagement: "إدارة الصلاحيات",
    roles: "الأدوار",
  },
  list: { title: "الصلاحيات", subtitle: "انشاء و ادارة الصلاحيات" },
  toolbar: {
    // The list screen's own toolbar button -- separate from actions.create,
    // which also labels the CRUD "create" permission in the matrix.
    add: "اضافة صلاحية",
    filters: "التصفية",
  },
  filters: {
    search: "البحث في الأدوار",
    searchPlaceholder: "ابحث بالاسم",
    status: "الحالة",
    statusAll: "كل الحالات",
  },
  status: {
    active: "نشط",
    inactive: "غير نشط",
  },
  table: {
    name: "الاسم",
    nameEn: "الاسم بالإنجليزية",
    nameAr: "الاسم بالعربية",
    permissionsCount: "عدد الصلاحيات",
    permissionsCountValue: "{{count}} صلاحية",
    status: "الحالة",
    createdAt: "تاريخ الإنشاء",
    actions: "الإجراءات",
    actionMenu: "إجراءات الدور",
    empty: "لا توجد أدوار مطابقة للتصفية.",
    error: "تعذر تحميل الأدوار.",
    loading: "جارٍ تحميل الأدوار",
    showing: "عرض {{count}} من {{total}}",
    rowsPerPageLabel: "عرض الصفوف",
    nextPage: "الصفحة التالية",
    previousPage: "الصفحة السابقة",
    pagination: "ترقيم الصفحات",
    sortAscending: "ترتيب تصاعدي",
    sortDescending: "ترتيب تنازلي",
  },
  deleteDialog: {
    title: "حذف",
    question: "هل أنت متأكد أنك تريد حذف هذا الدور؟",
    warning: "هذا الإجراء دائم ولا يمكن التراجع عنه.",
    confirmWord: "حذف",
    instruction: 'اكتب "{{word}}" لتأكيد الحذف',
    inputLabel: "تأكيد الحذف",
    cancel: "إلغاء",
    confirm: "حذف",
    close: "إغلاق نافذة الحذف",
    success: "تم حذف الدور بنجاح.",
  },
  form: {
    createTitle: "إنشاء دور",
    // Used only for the breadcrumb crumb on create -- the page heading
    // itself stays createTitle.
    createBreadcrumb: "إنشاء صلاحية",
    editTitle: "تعديل الدور",
    createSubtitle: "أدخل اسم الدور وحدد صلاحياته.",
    editSubtitle: "تحديث اسم الدور وحالته وصلاحياته.",
    back: "العودة إلى الصلاحيات",
    details: "تفاصيل الدور",
    nameEn: "الاسم بالإنجليزية",
    nameAr: "الاسم بالعربية",
    isActive: "نشط",
    statusDialog: {
      titleActivate: "تفعيل الدور",
      titleDeactivate: "إلغاء تفعيل الدور",
      questionActivate: "هل أنت متأكد أنك تريد تفعيل هذا الدور؟",
      questionDeactivate: "هل أنت متأكد أنك تريد إلغاء تفعيل هذا الدور؟",
      note: "لن يتم تطبيق هذا التغيير إلا بعد الحفظ.",
      yes: "نعم",
      no: "لا",
      close: "إغلاق نافذة تغيير الحالة",
    },
    loading: "جارٍ تحميل الدور",
    loadError: "تعذر تحميل الدور.",
  },
  matrix: {
    title: "الصلاحيات",
    description: "اختر الصلاحيات المتاحة لهذا الحساب.",
    expand: "توسيع",
    collapse: "طي",
  },
  detail: {
    title: "تفاصيل الدور",
    subtitle: "التفاصيل والمعلومات الأساسية للملف",
    loading: "جارٍ تحميل الدور",
    error: "تعذر تحميل الدور.",
    notAvailable: "غير متاح",
  },
};

export default roles;
